module.exports = __webpack_public_path__ + "img/Launch.884023e4.png";